import { REQUESTABLE_USERS_URL_GET } from '../../../services/ExternalService/constants';

const MERGED_FIELDS = new Set<string>();

const COLUMN_LABEL_MAP: Record<string, string> = {
  username: 'Username',
  firstname: 'First Name',
  lastname: 'Last Name',
  middlename: 'Middle Name',
  displayname: 'Display Name',
  statuskey: 'Status',
  startdate: 'Start Date',
  enddate: 'End Date',
  manager: 'Manager',
  customer: 'Customer',
  employeeType: 'Employee Type',
  departmentname: 'Department',
  employeeid: 'Employee ID',
  email: 'Email',
  userSource: 'Identity Source',
  identityType: 'Identity Type',
  title: 'Title',
  city: 'City',
  secondaryManager: 'Secondary Manager',
  location: 'Location',
};

const COLUMN_MIN_WIDTH_MAP: Record<string, string> = {
  username: '12.75rem',
  firstname: '10rem',
  lastname: '10rem',
  middlename: '10rem',
  displayname: '11rem',
  statuskey: '7rem',
  startdate: '10rem',
  enddate: '10rem',
  manager: '10rem',
  customer: '10rem',
  employeeType: '11rem',
  departmentname: '11rem',
  employeeid: '10rem',
  email: '12rem',
  userSource: '11rem',
  identityType: '11rem',
  title: '9rem',
  city: '9rem',
  secondaryManager: '12rem',
  location: '10rem',
};

// Fields that are unchecked by default in the column settings
const UNCHECKED_BY_DEFAULT = new Set([
  'firstname',
  'lastname',
  'middlename',
  'displayname',
  'startdate',
  'enddate',
  'customer',
  'departmentname',
  'employeeid',
  'identityType',
  'title',
  'city',
  'secondaryManager',
  'location',
]);

const parseResponseFields = (url: string): string[] => {
  const match = url.match(/responsefields=([^&]+)/);

  if (!match) {
    return [];
  }

  return match[1].split(',').filter((f) => !MERGED_FIELDS.has(f));
};

const responseFields = parseResponseFields(REQUESTABLE_USERS_URL_GET);

const dynamicColumns = responseFields.map((field) => ({
  key: field,
  value: field,
  label: COLUMN_LABEL_MAP[field] || field,
  isChecked: !UNCHECKED_BY_DEFAULT.has(field),
  isPinned: false,
  isSortable: false,
  isColumnConfigEnabled: true,
  minWidth: COLUMN_MIN_WIDTH_MAP[field] || '10rem',
}));

const INITIAL_USER_LIST_COLUMNS = [
  { ...dynamicColumns[0], isPinned: true }, // username is pinned
  ...dynamicColumns.slice(1),
  {
    key: 'actionColumn',
    value: 'actionColumn',
    label: 'actionColumn',
    isChecked: true,
    isPinned: true,
    isColumnConfigEnabled: true,
    minWidth: 'min-content',
  },
];

export default INITIAL_USER_LIST_COLUMNS;
